import { render, staticRenderFns } from "./EditorGroupShow.vue?vue&type=template&id=d09806e0&"
import script from "./EditorGroupShow.vue?vue&type=script&lang=js&"
export * from "./EditorGroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports